import dayjs from 'dayjs'
import { useCallback, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import styled from 'styled-components'
import { v4 as uuid } from 'uuid'
import api from '../../../api'
import Responsive from '../../../assets/config/Responsive'
import DoubleRightIcon from '../../../assets/icons/JSX/DoubleRightIcon'
import RightArrow from '../../../assets/icons/JSX/RightArrow'
import Colors from '../../../assets/styles/Colors'
import { Container } from '../../../assets/styles/GlobalStyle'
import CubesIcon from '../../../assets/v2/JSX/CubesIcon'
import StarIcon from '../../../assets/v2/JSX/StarIcon'
import Loader from '../../../components/Loader'
import BackgroundIcon from '../../../components/v2/BackgroundIcon'
import CountBar from '../../../components/v2/CountBar'
import Dropdown from '../../../components/v2/Dropdown'
import RemainingCompanies from '../../../components/v2/RemainingCompanies'
import ScreenHeader from '../../../components/v2/ScreenHeader'
import Title from '../../../components/v2/Title'
import PriceAccordion from '../../../components/v2/accordions/PriceAccordion'
import NavigationButton from '../../../components/v2/buttons/NavigationButton'
import ToggleSwitcher from '../../../components/v2/buttons/ToggleSwitcher'
import AbroadProgressBar from '../../../components/v2/progrees-bars/AbroadProgressBar'
import { AbroadOffer, currencySymbol, georgianFormatter } from '../../../domain/types'
import { useAppDispatch, useAppSelector } from '../../../store'
import { AppState } from '../../../store/appSlice'
import {
  TravelAbroadState,
  clearAddon,
  clearGroupAddon,
  removeAddon,
  removeGroupAddon,
  setAddon,
  setBetterOffer,
  setCompanyOffers,
  setCurrency,
  // setFranchise,
  setGroupAddon,
  setHeaderPassedCount,
  setLimit,
  setOffer,
  setUniquedId,
  updateAddon,
  updateGroupAddon,
} from '../../../store/travelAbroadSlice'
//
//
const TravelOffers = () => {
  //
  const dispatch = useAppDispatch()
  //
  const { filter, screenHeader } = useAppSelector((data: { travelAbroad: TravelAbroadState }) => data.travelAbroad)
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const { t } = useTranslation()
  //
  const navigate = useNavigate()
  //
  //
  const [openAddonAccordion, setOpenAddonAccordion] = useState<boolean>(false)
  //
  //
  const [abroadBestOffer, { isLoading: isBestOFferLoading, data: offers }] = api.useNewAbroadBestOfferMutation()
  //
  //
  //
  const setOfferCompanyCallBack = useCallback(async () => {
    if (offers && offers.length >= 1) {
      dispatch(setCompanyOffers(offers))
    }
    //
  }, [offers, dispatch])
  //
  //
  useEffect(() => {
    setOfferCompanyCallBack()

    return () => {}
  }, [setOfferCompanyCallBack])
  //
  //
  //
  // travel currencies
  const { data: travelCurrencies, isLoading: isTravelCurrenciesLoading } = api.useGetTravelCurrenciesQuery('usd-eur')
  //
  //
  // get travel limits by currency
  const { data: travelLimitsByCurrency } = api.useGetTravelLimitsByCurrencyQuery(filter.currency as string, {
    skip: !filter.currency && true,
  })
  //
  //
  // const { data: travelFranchiseByLimits, isLoading: isTravelFranchiseByLimitsLoading } =
  //   api.useGetTravelFranchiseByLimitsQuery(
  //     {
  //       limit: filter.limit as number,
  //       currency: filter.currency as string,
  //     },
  //     {
  //       skip: (!filter.limit || !filter?.currency) && true,
  //     },
  //   )
  //
  //
  // const lowestFranchise = travelFranchiseByLimits && Math.min(...travelFranchiseByLimits?.map((x) => x.value))
  //
  //
  //
  //
  const offerCallBack = useCallback(async () => {
    const GeneratedUniqueId = uuid()
    //
    const localSelectedTravel = filter.singleOrMulti?.split('-')[0] // 'single' or 'multi'
    //
    if (
      filter.productCategory &&
      filter.chooseMethod &&
      localSelectedTravel &&
      filter.region &&
      filter.currency &&
      filter.limit &&
      filter.travelersDate
    ) {
      try {
        //
        dispatch(setUniquedId(GeneratedUniqueId))
        //
        await abroadBestOffer({
          betterOffer: filter.betterOffer || false,
          categorySlug: filter.productCategory,
          whoChoseCompany: filter.chooseMethod,
          userChoseCompanies: filter.selectedCompanies,
          selectedTravel: localSelectedTravel,
          travelMultiDay: localSelectedTravel === 'multi' ? (filter.multiDays?.days as number) : undefined,
          travelDates:
            localSelectedTravel === 'multi'
              ? {
                  start: filter.multiDates?.start as string,
                  end: filter.multiDates?.end as string,
                }
              : {
                  start: filter.singleDates?.start as string,
                  end: filter.singleDates?.end as string,
                },
          travelArea: filter.region,
          selectedPackage: {
            currency: filter.currency,
            limit: filter.limit,
            franchise: undefined, //filter.franchise
          },
          // travelersAge: filter.travelersDate?.map((t) => t.age),
          travelersAge: filter.travelersDate?.map((item) => (item.month === null ? item.age : 0)),
          selectedCoverages: [],
          uniqueId: GeneratedUniqueId,
          travelersBirthdays: filter.travelersDate?.map((t) => ({
            age: t.age,
            birthday: dayjs(t.dateFormat).format('YYYY-MM-DD'),
          })),
        }).unwrap()
        //
      } catch (error: any) {
        if (error?.data?.errors?.constructor === Array) {
          const firstError = error.data.errors[0]
          const errorMessage = firstError.message
          toast.error(errorMessage, { toastId: 'some-id-here' })
          //
        } else {
          toast.error('Some error message')
        }
      }
    }
    //

    //
  }, [
    filter.betterOffer,
    filter.productCategory,
    filter.chooseMethod,
    filter.selectedCompanies,
    filter.region,
    filter.currency,
    filter.limit,
    // filter.franchise,
    filter.multiDates?.end,
    filter.multiDates?.start,
    filter.multiDays?.days,
    filter.singleOrMulti,
    filter.travelersDate,
    filter.singleDates?.start,
    filter.singleDates?.end,
    dispatch,
    abroadBestOffer,
  ])
  //
  //
  useEffect(() => {
    //
    offerCallBack()
    //
    return () => {}
  }, [offerCallBack])
  //
  //
  const atAddonsOnceTotalPrice =
    filter.attachedAddons && filter.attachedAddons.length >= 1
      ? filter.attachedAddons
          .filter((x) => x.addon.paymentType === 'ONCE')
          ?.reduce((accumulator, item) => accumulator + parseInt(item.addon.premium, 10) * item.count, 0)
      : 0
  //
  //
  const atAddonsDailyTotalPrice =
    filter.attachedAddons && filter.attachedAddons.length >= 1
      ? filter.attachedAddons
          ?.filter((x) => x.addon.paymentType === 'DAILY')
          ?.reduce(
            (accumulator, item) =>
              accumulator +
              parseInt(item.addon.premium, 10) * (offers?.[0]?.calculatedPrices?.insurancesDays || 0) * item.count,
            0,
          )
      : 0
  //
  //
  // groupe dAttached Addons Addons Calculate the total price
  const groupOnceAddonsTotalPrice =
    filter.groupedAttachedAddons && filter.groupedAttachedAddons.length >= 1
      ? filter.groupedAttachedAddons
          ?.filter((x) => x.addon.paymentType === 'ONCE')
          ?.reduce((accumulator, item) => accumulator + item.addon.premium * item.count, 0)
      : 0
  //
  //
  const groupDailyAddonsTotalPrice =
    filter.groupedAttachedAddons && filter.groupedAttachedAddons.length >= 1
      ? filter.groupedAttachedAddons
          ?.filter((x) => x.addon.paymentType === 'DAILY')
          ?.reduce(
            (accumulator, item) =>
              accumulator + item.addon.premium * (offers?.[0]?.calculatedPrices?.insurancesDays || 0) * item.count,
            0,
          )
      : 0
  //
  //
  //
  const allAddonPrice =
    atAddonsOnceTotalPrice + groupOnceAddonsTotalPrice + atAddonsDailyTotalPrice + groupDailyAddonsTotalPrice
  //
  //
  //
  //
  //
  // #########################################################
  //
  // const offerList = offers || []
  // //
  // const lowestPrice = Math.min(...offerList.map((offer) => offer.calculatedPrices.totalPremium))
  // const lowestPriceIndexes: number[] = []
  // const updatedOffers: AbroadOffer[] = []
  // //
  // for (let i = 0; i < offerList.length; i++) {
  //   if (offerList[i].calculatedPrices.totalPremium === lowestPrice) {
  //     lowestPriceIndexes.push(i)
  //   } else {
  //     updatedOffers.push(offerList[i])
  //   }
  // }
  // //
  // const centerIndex = Math.floor(updatedOffers.length / 2)
  // //
  // lowestPriceIndexes.forEach((index) => {
  //   updatedOffers.splice(centerIndex, 0, offerList[index])
  // })
  //
  // #########################################################
  //
  //
  // find minimal franchise and price and return random
  const findBestOfferTwoType = () => {
    const initialOffers = offers

    if (filter.betterOffer === true && initialOffers) {
      //
      const bestOffers: any = []
      let bestPrice = Number.MAX_VALUE
      let bestFranchise = Number.MAX_VALUE

      const mutableOffers = initialOffers && [...initialOffers] // Create a mutable copy

      mutableOffers.forEach((offer: AbroadOffer) => {
        if (
          offer.calculatedPrices.totalPremium < bestPrice ||
          (offer.calculatedPrices.totalPremium === bestPrice && offer.calculatedPrices.franchise < bestFranchise)
        ) {
          bestPrice = offer.calculatedPrices.totalPremium
          bestFranchise = offer.calculatedPrices.franchise
          bestOffers.length = 0 // Clear previous best offers
          bestOffers.push(offer as never)
        } else if (
          offer.calculatedPrices.totalPremium === bestPrice &&
          offer.calculatedPrices.franchise === bestFranchise
        ) {
          bestOffers.push(offer as never)
        }
      })

      const updatedOffers = mutableOffers.filter((offer) => !bestOffers?.includes(offer as never))
      const middleIndex = Math.floor(updatedOffers.length / 2)
      // @ts-ignore
      updatedOffers.splice(middleIndex, 0, ...bestOffers.map((bestOffer) => ({ ...bestOffer, isBest: true })))

      return updatedOffers // Return the updatedOffers array
    }
    //
    //
    if (filter.betterOffer === false && initialOffers) {
      //
      //
      const markLowestPriceAsBest = () => {
        const lowestPrice = Math.min(...initialOffers.map((product) => product.calculatedPrices.totalPremium))
        const updatedProducts = initialOffers.map((product) => {
          if (product.calculatedPrices.totalPremium === lowestPrice) {
            return { ...product, isBest: true }
          }
          return { ...product, isBest: false }
        })
        return updatedProducts
      }
      //
      const updatedProductsArray = markLowestPriceAsBest()
      //
      return updatedProductsArray
    }

    return initialOffers // Return the original initialOffers array
  }
  //
  const sortedOffers = findBestOfferTwoType()
  //
  //
  //
  // isTravelFranchiseByLimitsLoading
  const mainLoader = isBestOFferLoading || isTravelCurrenciesLoading
  //
  return mainLoader ? (
    <Loader />
  ) : (
    <Wrapper>
      <Helmet>
        <title>{t('offer')}</title>
        <meta name="description" content={`${t('offer')}`} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <ScreenHeader totalCount={screenHeader.totalCount} passedCount={screenHeader.passedCount} />
      <Content>
        <Title text={t('offer')} />

        <AbroadProgressBar stepName={`${t('offers')}`} />
      </Content>

      <Container>
        {/*  */}
        <CustomBetterOffer
          style={{
            userSelect: sortedOffers && sortedOffers.length >= 1 ? 'unset' : 'none',
            pointerEvents: sortedOffers && sortedOffers.length >= 1 ? 'unset' : 'none',
            opacity: sortedOffers && sortedOffers.length >= 1 ? 'unset' : '0.6',
          }}
        >
          <StarIcon />
          <span className="better-offer-span">{t('getBetterOffer')}</span>
          <ToggleSwitcher
            defaultValue={filter.betterOffer}
            onChange={(value) => {
              if (value === true) {
                // dispatch(setFranchise(lowestFranchise)),
                return [dispatch(setBetterOffer(true))]
              } else {
                // dispatch(setFranchise(undefined)),
                return [dispatch(setBetterOffer(false))]
              }
            }}
          />
        </CustomBetterOffer>
        {/*  */}
        <DropDownBlock>
          <DropdownCustomStyle>
            <span className="dropdown-value-span">{t('currency')}</span>
            <Dropdown
              title={`${t('currency')}`}
              value={offers?.[0]?.calculatedPrices?.compensationCurrency || filter.currency}
              options={travelCurrencies?.map((x) => ({
                value: x.type,
                label: x.type?.toUpperCase(),
              }))}
              placeholder={``}
              onChange={(obj) => {
                dispatch(setCurrency(obj.value))
              }}
            />
          </DropdownCustomStyle>

          <VerticalLine />

          <DropdownCustomStyle>
            <span className="dropdown-value-span">{t('limit')}</span>
            <Dropdown
              title={`${t('limit')}`}
              value={offers?.[0]?.calculatedPrices?.compensationLimit || filter.limit}
              options={travelLimitsByCurrency?.map((x) => ({
                value: x.value,
                label:
                  x.value?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') +
                  ` ${currencySymbol(filter.currency || offers?.[0]?.calculatedPrices?.compensationCurrency)}`,
              }))}
              placeholder={``}
              onChange={(obj) => {
                dispatch(setLimit(Number(obj.value)))
              }}
            />
          </DropdownCustomStyle>
        </DropDownBlock>
        {/*  */}
        {/*  */}
        {sortedOffers && sortedOffers.length >= 1 ? null : (
          <RemainingCompanies
            style={{
              marginInline: 'auto',
              width: 'fit-content',
              marginTop: '20px',
            }}
            text={t('offerNotFound')}
          />
        )}
        {/*  */}
        {/*  */}

        <Block>
          {(sortedOffers && sortedOffers.length >= 1 ? sortedOffers : filter.companyOffers)?.map((item, index) => {
            //
            //
            const showAtAddons =
              item.travelAttachedAddons?.filter((item) => typeof item === 'object')?.length >= 1 ? true : false
            //
            const showGroupAtAddons =
              item.groupedTravelAttachedAddonInfos?.filter((item) => typeof item === 'object')?.length >= 1
                ? true
                : false
            //
            return (
              <PriceAccordion
                key={index}
                isBestPrice={item.isBest ? true : false}
                price={`${georgianFormatter.format(item?.calculatedPrices?.totalPremium as number)} ₾`}
                addonsPrice={
                  filter.offer?.companyId === item?.companyId && allAddonPrice ? allAddonPrice?.toString() : undefined
                }
                docUrl={
                  item?.productWording?.includes('translations')
                    ? JSON.parse(item?.productWording)?.translations?.[lang]?.url
                    : undefined
                }
                headTitle={item?.brandName?.[lang]?.title}
                imgUrl={item?.companyLogo}
                isSelected={item?.companyId === filter.offer?.companyId ? true : false}
                onClick={() => {
                  if (item?.companyId === filter.offer?.companyId ? true : false) {
                    return [dispatch(setOffer(undefined)), dispatch(clearAddon([])), dispatch(clearGroupAddon([]))]
                  } else {
                    return [dispatch(setOffer(item)), dispatch(clearAddon([])), dispatch(clearGroupAddon([]))]
                  }
                }}
              >
                <HR />

                <TextDiv>
                  <LeftText>{t('currency')}</LeftText>
                  <RightText>{item?.calculatedPrices?.compensationCurrency?.toUpperCase()}</RightText>
                </TextDiv>

                <TextDiv>
                  <LeftText>{t('limit')}</LeftText>
                  <RightText>
                    {item?.calculatedPrices?.compensationLimit?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}{' '}
                    {currencySymbol(item?.calculatedPrices?.compensationCurrency)}
                  </RightText>
                </TextDiv>

                <TextDiv>
                  <LeftText>{t('franchise')}</LeftText>
                  <RightText>
                    {item?.calculatedPrices?.franchise} {currencySymbol(item?.calculatedPrices?.compensationCurrency)}
                  </RightText>
                </TextDiv>

                {showAtAddons || showGroupAtAddons ? (
                  <>
                    <HR />

                    <AddonsBlock>
                      <AddonAccordion>
                        <AddonHead onClick={() => setOpenAddonAccordion(!openAddonAccordion)}>
                          <CubesIconStyle />
                          <span>{t('additionalCoverages')}</span>
                          <RightArrowStyle
                            style={{
                              transform: openAddonAccordion ? 'rotate(-90deg)' : 'rotate(90deg)',
                            }}
                          />
                        </AddonHead>
                        {openAddonAccordion ? (
                          <AddonsContent
                            style={{
                              opacity: filter.offer?.companyId === item?.companyId ? 'unset' : '0.7',
                              pointerEvents: filter.offer?.companyId === item?.companyId ? 'unset' : 'none',
                              userSelect: filter.offer?.companyId === item?.companyId ? 'unset' : 'none',
                            }}
                          >
                            {item.travelAttachedAddons &&
                              item.travelAttachedAddons
                                .filter((x) => x && x.addonId)
                                ?.map((atAddon, atAddonIndex) => {
                                  //
                                  const attachedAddonsInitialCount =
                                    filter.offer?.companyId === item.companyId &&
                                    filter.attachedAddons?.find((x) => x.addon.addonId === atAddon.addonId)
                                  //
                                  return (
                                    <StandartAddon key={atAddonIndex}>
                                      <StandartAddonLeftSide>
                                        <span>{atAddon.addonTranslations?.[lang]?.title}</span>
                                        <span>
                                          {t('price')}: {atAddon.premium} ₾
                                          {atAddon.paymentType === 'ONCE' ? (
                                            <> / {t('coverageCost')}</>
                                          ) : (
                                            <> / {t('coverageCostByPerson')}</>
                                          )}
                                        </span>
                                        {filter.attachedAddons?.find((x) => x.addon.addonId === atAddon.addonId) ? (
                                          <span className="offer-addon-description">
                                            {atAddon.translations?.[lang]?.description}
                                          </span>
                                        ) : null}
                                      </StandartAddonLeftSide>
                                      <CountBar
                                        // this ts ignore not important
                                        // @ts-ignore
                                        initialCount={attachedAddonsInitialCount?.count ?? 0}
                                        step={1}
                                        maxCount={filter.travelersDate?.length}
                                        plusOnClick={(value) => {
                                          // create and set new addon
                                          if (
                                            filter.attachedAddons &&
                                            (filter.attachedAddons.length <= 0 ||
                                              filter.attachedAddons.find((x) => x.addon.addonId !== atAddon.addonId)) &&
                                            value === 1
                                          ) {
                                            // create new addon
                                            dispatch(setAddon({ addon: atAddon, count: value }))
                                          }
                                          //
                                          // update addon count
                                          if (filter.attachedAddons && filter.attachedAddons.length >= 1 && value > 1) {
                                            dispatch(updateAddon({ addonId: atAddon.addonId, count: value }))
                                          }
                                        }}
                                        minusOnClick={(value) => {
                                          // update addon count
                                          if (filter.attachedAddons && filter.attachedAddons.length >= 1) {
                                            dispatch(updateAddon({ addonId: atAddon.addonId, count: value }))
                                          }
                                          // remove addon by id
                                          if (
                                            filter.attachedAddons &&
                                            filter.attachedAddons.length >= 1 &&
                                            value === 0
                                          ) {
                                            //  remove addon by id
                                            dispatch(removeAddon(atAddon.addonId))
                                          }
                                        }}
                                      />
                                    </StandartAddon>
                                  )
                                })}

                            {item.groupedTravelAttachedAddonInfos &&
                              item.groupedTravelAttachedAddonInfos
                                .filter((x) => x && x.id)
                                ?.map((groupAddon, groupAddonIndex) => {
                                  //
                                  const groupAttachedAddonsInitialCount =
                                    filter.offer?.companyId === item.companyId &&
                                    filter.groupedAttachedAddons?.find((x) => x.addon.id === groupAddon.id)
                                  //
                                  return (
                                    <GroupAddon key={groupAddonIndex}>
                                      <StandartAddon>
                                        <StandartAddonLeftSide>
                                          <span>{groupAddon.translations?.[lang]?.title}</span>
                                          <span>
                                            {t('price')}: {groupAddon.premium} ₾
                                            {groupAddon.paymentType === 'ONCE' ? (
                                              <> / {t('coverageCost')}</>
                                            ) : (
                                              <> / {t('coverageCostByPerson')}</>
                                            )}
                                          </span>
                                        </StandartAddonLeftSide>
                                        <CountBar
                                          // this ts ignore not important
                                          // @ts-ignore
                                          initialCount={groupAttachedAddonsInitialCount?.count ?? 0}
                                          step={1}
                                          maxCount={filter.travelersDate?.length}
                                          plusOnClick={(value) => {
                                            //
                                            // create and set new addon
                                            if (
                                              filter.groupedAttachedAddons &&
                                              (filter.groupedAttachedAddons.length <= 0 ||
                                                filter.groupedAttachedAddons.find(
                                                  (x) => x.addon.id !== groupAddon.id,
                                                )) &&
                                              value === 1
                                            ) {
                                              // create new addon
                                              dispatch(setGroupAddon({ addon: groupAddon, count: value }))
                                            }
                                            //
                                            // update addon count
                                            if (
                                              filter.groupedAttachedAddons &&
                                              filter.groupedAttachedAddons.length >= 1 &&
                                              value > 1
                                            ) {
                                              dispatch(updateGroupAddon({ groupId: groupAddon.id, count: value }))
                                            }
                                            //
                                          }}
                                          minusOnClick={(value) => {
                                            // update addon count
                                            if (
                                              filter.groupedAttachedAddons &&
                                              filter.groupedAttachedAddons.length >= 1
                                            ) {
                                              dispatch(updateGroupAddon({ groupId: groupAddon.id, count: value }))
                                            }
                                            // remove addon by id
                                            if (
                                              filter.groupedAttachedAddons &&
                                              filter.groupedAttachedAddons.length >= 1 &&
                                              value === 0
                                            ) {
                                              //  remove addon by id
                                              dispatch(removeGroupAddon(groupAddon.id))
                                            }
                                          }}
                                        />
                                      </StandartAddon>

                                      {groupAddon.addons.map((innerGroupAddon, innerGroupAddonIndex) => (
                                        <GroupAddonDescription key={innerGroupAddonIndex}>
                                          <div
                                            style={{
                                              display: 'flex',
                                              alignItems: 'center',
                                            }}
                                          >
                                            <DoubleRightIcon />
                                            <span>{innerGroupAddon.addon.translations?.[lang]?.title}</span>
                                          </div>
                                          {filter.groupedAttachedAddons?.find((x) => x.addon.id === groupAddon.id) ? (
                                            <span className="offer-addon-description">
                                              {innerGroupAddon.description}
                                            </span>
                                          ) : null}
                                        </GroupAddonDescription>
                                      ))}
                                    </GroupAddon>
                                  )
                                })}
                          </AddonsContent>
                        ) : null}
                      </AddonAccordion>
                    </AddonsBlock>
                  </>
                ) : null}
              </PriceAccordion>
            )
          })}
        </Block>
      </Container>

      <Content>
        <Buttons>
          <NavigationButton
            text={`${t('back')}`}
            buttonType="prev"
            onClick={() => [
              dispatch(setHeaderPassedCount(screenHeader.passedCount - 1)),
              navigate('/choose-method'),
              dispatch(clearAddon([])),
              dispatch(clearGroupAddon([])),
            ]}
          />
          <NavigationButton
            disabled={filter.offer && offers && offers.length >= 1 ? false : true}
            text={`${t('next')}`}
            buttonType="next"
            onClick={() => [dispatch(setHeaderPassedCount(8)), navigate('/travel-offer')]}
          />
        </Buttons>
      </Content>

      <BackgroundIcon shortKite={true} />
    </Wrapper>
  )
}
//
const GroupAddonDescription = styled.p`
  font-size: 14px;
  color: ${Colors.primaryBlack};
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;

  svg {
    width: 11px;
    margin-right: 9px;
    margin-top: 1px;
  }

  .offer-addon-description {
    font-size: 14px;
    color: ${Colors.primaryBlack};
    margin-top: 10px;
    color: ${Colors.nevadaGrey};
  }
`
const StandartAddonLeftSide = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 14px;
  color: ${Colors.primaryBlack};
  text-align: left;

  span {
    :not(:first-child) {
      color: ${Colors.nevadaGrey};
    }
  }

  .offer-addon-description {
    margin-right: 20px;
    margin-top: 10px;
  }
`
const StandartAddon = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 22px;

  &:not(:last-child) {
    border-bottom: 1px solid ${Colors.secondaryGrey};
    padding-bottom: 22px;
  }
`
const GroupAddon = styled.div`
  margin-top: 22px;

  &:not(:last-child) {
    border-bottom: 1px solid ${Colors.secondaryGrey};
    padding-bottom: 22px;
  }

  ${StandartAddon} {
    margin-top: 0px;
    border-bottom: unset;
    padding-bottom: 0px;
  }
`
const AddonsContent = styled.div`
  /*  */
`
const RightArrowStyle = styled(RightArrow)`
  width: 20px;
  margin-left: auto;
  transform: scale(1.1);
`
const CubesIconStyle = styled(CubesIcon)`
  width: 32px;
  height: 32px;
  margin-right: 17px;
`
const AddonHead = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;

  span {
    font-size: 14px;
    color: ${Colors.primaryBlack};
  }
`
const AddonAccordion = styled.div`
  /*  */
`
const AddonsBlock = styled.div`
  /*  */
`
const RightText = styled.div``
const LeftText = styled.div``
const TextDiv = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${Colors.nevadaGrey};
  font-size: 14px;
  &:not(:last-child) {
    margin-bottom: 14px;
  }
`
const CustomBetterOffer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-block: 32px 24px;

  .better-offer-span {
    margin-inline: 8px 18px;
    font-size: 18px;
    line-height: 17px;
    color: ${Colors.primaryBlack};
  }
  svg {
    color: ${Colors.secondaryGrey};
  }

  ${Responsive.mobile} {
    margin-block: 24px;
  }
`
const VerticalLine = styled.div`
  width: 1px;
  height: 24px;
  background-color: ${Colors.secondaryGrey};
`
const DropdownCustomStyle = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  .dropdown-value-span {
    position: absolute;
    z-index: 2;
    left: 10px;
    color: ${Colors.nevadaGrey};
    font-size: 14px;
    line-height: 14px;
    cursor: default;
    user-select: none;
    pointer-events: none;
  }
`
const DropDownBlock = styled.div`
  border: 1px solid ${Colors.secondaryGrey};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  margin-inline: auto;
  width: 400px;
  height: 56px;
  /*  */
  /*  */
  .dropdown-title-span {
    display: none;
  }
  .dropdown-wrapper {
    width: 100%;

    .v2-select__control {
      border: unset;
      background-color: transparent;
    }

    .v2-select__dropdown-indicator {
      padding: 0px;
    }

    .v2-select__single-value {
      display: flex;
      justify-content: flex-end;
      text-align: right;
    }
  }

  /*  */
  ${Responsive.mobile} {
    width: 100%;
    height: 48px;

    .dropdown-wrapper {
      .v2-select__value-container {
        padding-right: 10px;
      }
      .v2-select__dropdown-indicator {
        width: 24px;
      }
    }
  }
`

const HR = styled.hr`
  background-color: ${Colors.secondaryGrey};
  margin-block: 24px;
`

const Block = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  column-gap: 32px;
  row-gap: 20px;
  margin-top: 32px;
  position: sticky;
  z-index: 1;

  ${Responsive.tablet} {
    flex-direction: column;
  }

  ${Responsive.mobile} {
    flex-direction: column;
  }
`

const Buttons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-inline: auto;
  width: 100%;
  margin-top: 48px;
  max-width: 368px;

  button {
    width: 100%;
    padding-inline: 0px;
    &:first-child {
      margin-right: 20px;
    }
  }

  ${Responsive.mobile} {
    max-width: 296px;
    margin-top: 40px;
    button {
      &:first-child {
        margin-right: 15px;
      }
    }
  }
`
const Content = styled.div`
  margin-top: 58px;
  width: 100%;
  padding-inline: 20px;
  z-index: 1;

  ${Responsive.mobile} {
    margin-top: 26px;
  }
`
const Wrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
  background-color: ${Colors.backgroundGrey};
  padding-bottom: 20px;
  min-height: 100vh;
`
//
export default TravelOffers
